<div class="py-2" *ngIf="listInfo">
    <div class="pagination justify-content-end">
        <button
            class="btn px-1 py-0 rounded-circle m-1 go-to-first"
            (click)="onPageClick(0)"
            [ngClass]="{ disabled: listInfo.first }"
            [disabled]="listInfo.first"
        >
            <i class="fas fa-backward text-white"></i>
        </button>

        <button
            class="btn px-1 py-0 rounded-circle m-1"
            (click)="onPageChange(false)"
            [ngClass]="{ disabled: listInfo.first }"
            [disabled]="listInfo.first"
        >
            <i class="fas fa-caret-left text-white"></i>
        </button>

        <button
            class="btn px-1 py-0 rounded-circle m-1"
            *ngFor="let item of [].constructor(listInfo.totalPages); let i = index"
            [ngClass]="{ active: i === listInfo.number }"
            [disabled]="i === listInfo.number"
            [hidden]="!(i >= listInfo.number - 1 && i <= listInfo.number + 1)"
            (click)="onPageClick(i)"
        >
            <span class="text-white">{{ i + 1 }}</span>
        </button>

        <button
            class="btn px-1 py-0 rounded-circle m-1"
            (click)="onPageChange(true)"
            [ngClass]="{ disabled: listInfo.last }"
            [disabled]="listInfo.last"
        >
            <i class="fas fa-caret-right text-white"></i>
        </button>

        <button
            class="btn px-1 py-0 rounded-circle m-1 go-to-last"
            (click)="onPageClick(listInfo.totalPages - 1)"
            [ngClass]="{ disabled: listInfo.last }"
            [disabled]="listInfo.last"
        >
            <i class="fas fa-forward text-white"></i>
        </button>
    </div>
</div>
